import { gql } from '@apollo/client';
import type { InhubBaggingDestBucket } from '../types';

export const GET_INHUB_SORTING_BAGGING_DEST_DRILLDOWN = gql`
  query GetInhubSortingBaggingDestDrilldown($filter: InhubDashboardRangeInput!) {
    getInhubSortingBaggingDestDrilldown(filter: $filter) {
      hubTotal
      whsTotal
      hubRows {
        destBucket
        targetId
        targetName
        baggingCount
      }
      whsRows {
        destBucket
        targetId
        targetName
        baggingCount
      }
    }
  }
`;

export interface InhubBaggingDestRowResp {
    destBucket: InhubBaggingDestBucket;
    targetId: number | null;
    targetName: string;
    baggingCount: number;
}

export interface GetInhubSortingBaggingDestDrilldownResponse {
    getInhubSortingBaggingDestDrilldown: {
        hubTotal: number;
        whsTotal: number;
        hubRows: InhubBaggingDestRowResp[];
        whsRows: InhubBaggingDestRowResp[];
    };
}
